import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Query } from 'react-apollo';

import Spinner from 'components/FullScreenSpinner';
import queryAttemptData from './queryAttemptData.gql';
import { transformResponse } from './mapQueryAttemptDataResponse';
import InteractivePlugin from './InteractivePlugin';

const DEFAULT_CONTEXT = 'REVIEW';

export default class PluginReviewContainer extends React.Component {
  static getDerivedStateFromProps(props, state) {
    if (state.containerRef.current) {
      state.containerRef.current.setComponentId(props.componentId);
    }
    return state;
  }

  constructor(props) {
    super(props);
    this.containerRef = React.createRef();
    this.state = {
      containerRef: this.containerRef,
    };
  }

  shouldComponentUpdate(nextProps) {
    const toCompare = ({ studentId, cohortId, deploymentId, interactiveId }) => ({
      studentId, cohortId, deploymentId, interactiveId });
    const a = toCompare(this.props);
    const b = toCompare(nextProps);
    return !_.isEqual(a, b);
  }

  render() {
    const { studentId, cohortId, deploymentId, interactiveId, componentId } = this.props;

    return (<Query
      query={queryAttemptData}
      variables={{ studentId, cohortId, deploymentId, interactiveId, componentId }}
    >
      {({ data, loading, error }) => {
        if (loading) {
          return <Spinner />;
        }

        if (error) {
          // Our graphql query will always throw an error if a different account doesn't have an
          // attempt for this component. We don't care about that.
          // FIXME: GraphQL query shouldn't be throwing an error in this case

          // eslint-disable-next-line no-console
          console.warn(error.message);
        }

        return (
          <InteractivePlugin
            {...transformResponse(data)}
            context={DEFAULT_CONTEXT}
            studentId={studentId}
            componentId={componentId}
            ref={this.containerRef}
          />
        );
      }}</Query>);
  }
}

PluginReviewContainer.propTypes = {
  studentId: PropTypes.string.isRequired,
  deploymentId: PropTypes.string.isRequired,
  cohortId: PropTypes.string.isRequired,
  componentId: PropTypes.string.isRequired,
  interactiveId: PropTypes.string.isRequired,
};
